export const injectJs = (src: string, onLoad?: () => void) => {
  const tag = document.createElement('script')

  tag.async = false
  tag.src = src
  if (onLoad) {
    tag.onload = onLoad
  }

  document.body.appendChild(tag)
}
